import ApiService from "@/core/services/api.service";

// action types
export const GET_INFORME = "getInforme";

export const SET_ERROR = "setError";
//const url = 'https://apifacturacionbot.contemporaseguros.com/facturacioncomisionapi'
//const url = 'https://localhost:44340'
const state = {
  errors: null,
};

const actions = {
  [GET_INFORME](context, datos) {
    return new Promise((resolve) => {
      //      ApiService.setHeader();//

      ApiService.get({ action: `/facturacioncomisionapi/api/Informe/v1/informe/${datos.anio}` }, "")
      // Dev
    //   ApiService.get({ action: `/api/Informe/v1/informe/${datos.anio}` }, "")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {

          context.commit(SET_ERROR, ""); //response.data.errors);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
};

export default {
  state,
  actions,
  mutations,
};
